import "normalize.css/normalize.css";
import "packages/chime-ui/custom.css";
import "custom-event-polyfill";
import "proxy-polyfill";

import type { AppProps } from "next/app";
import Head from "next/head";

import { NextIntlClientProvider } from "next-intl";

import { ThemeProvider } from "styled-components";

import { GlobalStyle } from "@src/packages/chime-ui/global";

import { useDatadog } from "@src/hooks/useDatadog";

import { RollbarProvider } from "@src/utils/rollbar";

import createApolloClient from "@src/queries/apolloClient";
import { ApolloProvider } from "@apollo/client/react";

const CIRCLE_SHA1 = process.env.CIRCLE_SHA1 ?? "";
const rollbarClientToken = process.env.ROLLBAR_TOKEN ?? "";
const deployEnvironment = process.env.DEPLOY_ENVIRONMENT ?? "";

function MyApp({ Component, pageProps }: AppProps) {
  useDatadog();
  const client = createApolloClient();

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <NextIntlClientProvider locale="en-US" messages={pageProps.messages}>
        <ApolloProvider client={client}>
          <RollbarProvider accessToken={rollbarClientToken} environment={deployEnvironment} codeVersion={CIRCLE_SHA1}>
            <ThemeProvider theme={{}}>
              <GlobalStyle />
              <Component {...pageProps} />
            </ThemeProvider>
          </RollbarProvider>
        </ApolloProvider>
      </NextIntlClientProvider>
    </>
  );
}

export default MyApp;
